function initPlaceholder() {
	$('.js-mobile-placeholder').each(function() {
		const $this = $(this);
		const mobilePlaceholder = $this.data('mobile-placeholder');

		if ($(window).width() < 768) {
			$this.attr('placeholder', mobilePlaceholder)
		}
	});
}

initPlaceholder();

export default initPlaceholder;
